import { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { login } from '../api/authApi';
import { setToken } from '../utils/tokenUtils';
import styles from './LoginPage.module.css';
import global from '../styles/global.module.css';

function LoginPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from || '/';
    const [form, setForm] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const response = await login(form);
            setToken(response.data);
            navigate(from, { replace: true });
        } catch (err) {
            setError('이메일 또는 비밀번호가 올바르지 않습니다.');
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.box}>
                <h1 className={global.pageLogo}>SHOP</h1>
                <p className={global.pageSubtitle}>로그인</p>

                {error && <p className={global.errorText}>{error}</p>}

                <form onSubmit={handleSubmit} className={styles.form}>
                    <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        className={global.input}
                        placeholder="이메일"
                    />
                    <div style={{ position: 'relative' }}>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            name="password"
                            value={form.password}
                            onChange={handleChange}
                            className={global.input}
                            placeholder="비밀번호"
                            style={{ paddingRight: '44px' }}
                        />
                        <button
                            type="button"
                            onClick={() => setShowPassword(prev => !prev)}
                            style={{
                                position: 'absolute', right: '12px', top: '50%',
                                transform: 'translateY(-50%)', background: 'none',
                                border: 'none', cursor: 'pointer', fontSize: '16px', color: '#888'
                            }}>
                            {showPassword ? (
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2">
                                    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94"/>
                                    <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/>
                                    <line x1="1" y1="1" x2="23" y2="23"/>
                                </svg>
                            ) : (
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#888" strokeWidth="2">
                                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                                    <circle cx="12" cy="12" r="3"/>
                                </svg>
                            )}
                        </button>
                    </div>
                    <button type="submit" className={global.btnPrimary}>
                        로그인
                    </button>
                </form>

                <div className={global.divider} />

                <Link to="/register" className={global.btnOutline}>
                    회원가입
                </Link>

                <p className={styles.findLinks}>
                    <Link to="/forgot-password?tab=findEmail" className={styles.findLink}>아이디 찾기</Link>
                    <span className={styles.separator}>/</span>
                    <Link to="/forgot-password?tab=findPassword" className={styles.findLink}>비밀번호 찾기</Link>
                </p>
            </div>
        </div>
    );
}

export default LoginPage;